import jwtService from 'app/auth/store/actions/jwtService';
import decode from 'jwt-decode';
import { USER_ROLE } from 'app/main/util/enums';

export const getDefaultRoute = () => {
    try {
        const token = jwtService.getAccessToken()
        const decoded = decode(token)
        const user = decoded.user
        if (user.role.includes(USER_ROLE.DEMO)) return '/landing-page'  // Demo users land on campaign landing page
        if (user.role.includes(USER_ROLE.INSTRUCTOR)) return '/trainings'
        if (user.role.includes(USER_ROLE.PARTICIPANT)) return '/workshop-dashboard'  // Participants should land on workshop dashboard
        // All authenticated users (admin and non-admin) go to dashboard
        return '/dashboard'
    } catch (error) {
        return '/dashboard'
    }
}